import {version} from "../../../../package.json";

import EdgeLoading from "@/containers/LoadingData/EdgeLoading/EdgeLoading";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import styles from "./Loader.module.scss";

export default function Loader({text, variant = "appScreen", ...rest}) {
  const isWhiteLabelApp = window.config.isWhiteLabelApp;
  const isForth = window.config.websiteId === 1;
  const isEdge = window.config.websiteId === 2;
  const isBiomarkerTracking = !isWhiteLabelApp && window.config.websiteId === 3;

  return (
    <div id={styles.loaderScreen} variant={variant} data-screen="loadingScreen" {...rest}>
      <RenderIf isTrue={!isWhiteLabelApp && (isForth || isBiomarkerTracking)}>
        <div className="align-self-end">
          <svg
            className={`${styles.pl} col-12"`}
            viewBox="-5 -5 170 170"
            width="90"
            height="90"
            xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="pl-grad1" x1="1" y1="0.5" x2="0" y2="0.5">
                <stop offset="0%" stopColor="hsl(6, 0%, 10%)" />
                <stop offset="100%" stopColor="hsl(6, 0%, 10%)" />
              </linearGradient>
            </defs>

            <path
              className={`${styles.pl__ring}`}
              id="Path_2132"
              cx="100"
              cy="100"
              r="82"
              fill="none"
              stroke="url(#pl-grad1)"
              strokeWidth="2"
              d="M737.441,586.442a66.209,66.209,0,1,0,66.169,68.4l.04-.011V586.442Zm33.669,67.315-.021.006a33.667,33.667,0,1,1-33.649-34.78h33.669Z"
              transform="translate(-889.311 153.589) rotate(-45)"
              dasharray="0 257 1 257"
            />
          </svg>
          {text && <p className="col-12 text-center">{text}</p>}
        </div>
      </RenderIf>

      <RenderIf isTrue={isWhiteLabelApp}>
        <div className="align-self-end">
          <div className={styles.customLoader} role="status"></div>
          {text && <p className="col-12 text-center">{text}</p>}
        </div>
      </RenderIf>

      <RenderIf isTrue={!isWhiteLabelApp && isEdge}>
        <div className="align-self-end">
          <EdgeLoading showMessage={false} text="Loading" />
        </div>
      </RenderIf>
      <span className={`${styles.version} col-12 text-end`}>{`v${version}`}</span>
    </div>
  );
}
